import { Endpoint } from '../endpoint';
import { LibraryDocumentResponse, LibraryDocumentId, LibraryDocumentParams } from '@business/entities/libraryDocument';
import { R } from '@core/utils/r';

export function fetchForms(data?: LibraryDocumentParams) {
  const params = R.objectCompact(data);
  return Endpoint.get<LibraryDocumentResponse[]>(`@gc/library-document`, { params: params });
}

export function fetchForm(id: LibraryDocumentId) {
  return Endpoint.get<LibraryDocumentResponse>(`@gc/library-document/form/${id}`);
}

export function createForm(data: Partial<LibraryDocumentResponse>) {
  return Endpoint.post<LibraryDocumentResponse>(`@gc/library-document`, { data });
}

export function updateForm(id: LibraryDocumentId, data: Partial<LibraryDocumentResponse>) {
  return Endpoint.patch<LibraryDocumentResponse>(`@gc/library-document/${id}`, { data });
}

export function updateFormKey(id: LibraryDocumentId, key: string, value: boolean | string | number) {
  const data = R.objectCompact({ key, value });
  return Endpoint.patch<LibraryDocumentResponse>(`@gc/library-document/update-form/${id}`, { data });
}

export function deleteForm(id: LibraryDocumentId) {
  return Endpoint.delete<void>(`@gc/library-document/${id}`);
}

export function duplicateForm(id: LibraryDocumentId, data: Partial<LibraryDocumentResponse>) {
  return Endpoint.post<LibraryDocumentResponse>(`@gc/library-document/duplicate/${id}`, { data });
}

export function saveFormFields(id: LibraryDocumentId, data: Pick<LibraryDocumentResponse, 'fields'>) {
  return Endpoint.post<LibraryDocumentResponse>(`@gc/library-document/save-fields/${id}`, { data });
}
